var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfoSetlitesec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.725,
    height: 97.43,
    viewBox: "0 0 119.725 97.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ufo_setlitesec",
    transform: "translate(-1093.29 -593.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8731",
    "data-name": "Group 8731",
    transform: "translate(1093.29 593.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8729",
    "data-name": "Group 8729",
    transform: "translate(41.888 42.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44063",
    "data-name": "Path 44063",
    d: "M1134.156,634.75l18.99,10.972-.573,1.158L1133.6,635.95l.049-.747Z",
    transform: "translate(-1133.457 -634.726)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44064",
    "data-name": "Path 44064",
    d: "M1133.463,635.6c0,.316.193.461.43.324a1.027,1.027,0,0,0,.43-.821c0-.316-.192-.462-.43-.324A1.028,1.028,0,0,0,1133.463,635.6Z",
    transform: "translate(-1133.463 -634.727)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8730",
    "data-name": "Group 8730",
    transform: "translate(41.888 34.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44065",
    "data-name": "Path 44065",
    d: "M1134.156,626.783l18.99,10.972-.573,1.157L1133.6,627.984l.049-.747Z",
    transform: "translate(-1133.457 -626.76)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44066",
    "data-name": "Path 44066",
    d: "M1133.463,627.633c0,.316.193.462.43.324a1.026,1.026,0,0,0,.43-.821c0-.316-.192-.461-.43-.324A1.03,1.03,0,0,0,1133.463,627.633Z",
    transform: "translate(-1133.463 -626.761)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44067",
    "data-name": "Path 44067",
    d: "M1135.178,618.541l-41.888-24.154v28.284l41.888,24.154Z",
    transform: "translate(-1093.29 -593.462)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44068",
    "data-name": "Path 44068",
    d: "M1135.129,616.665l-1.666.926v28.285l1.666-.926Z",
    transform: "translate(-1091.575 -592.511)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44069",
    "data-name": "Path 44069",
    d: "M1133.787,619.428l-39.151-22.573v24.931l39.151,22.574Z",
    transform: "translate(-1093.232 -593.357)",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44070",
    "data-name": "Path 44070",
    d: "M1136.844,617.654l-1.666.926-41.888-24.154,1.666-.926Z",
    transform: "translate(-1093.29 -593.5)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3017",
    "data-name": "Rectangle 3017",
    width: 0.666,
    height: 27.157,
    transform: "translate(8.565 6.477)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3018",
    "data-name": "Rectangle 3018",
    width: 0.666,
    height: 27.157,
    transform: "translate(16.729 11.602)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3019",
    "data-name": "Rectangle 3019",
    width: 0.667,
    height: 27.157,
    transform: "translate(24.893 15.976)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3020",
    "data-name": "Rectangle 3020",
    width: 0.666,
    height: 27.157,
    transform: "translate(33.057 21.101)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44071",
    "data-name": "Path 44071",
    d: "M1134.609,627.091,1093.6,603.446v.923l41.005,23.645Z",
    transform: "translate(-1093.276 -593.076)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44072",
    "data-name": "Path 44072",
    d: "M1134.609,635.605,1093.6,611.96v.923l41.005,23.645Z",
    transform: "translate(-1093.276 -592.712)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8734",
    "data-name": "Group 8734",
    transform: "translate(1116.168 620.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8733",
    "data-name": "Group 8733",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    cx: 8.512,
    cy: 15.046,
    rx: 8.512,
    ry: 15.046,
    transform: "matrix(0.92, -0.392, 0.392, 0.92, 31.056, 6.666)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44073",
    "data-name": "Path 44073",
    d: "M1134.907,668.418l31.3-18.157-12.9-27.115-31.049,18.013Z",
    transform: "translate(-1114.932 -619.551)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8732",
    "data-name": "Group 8732",
    transform: "translate(13.67 4.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44074",
    "data-name": "Path 44074",
    d: "M1161.976,653.038l0,0c2.246-1.2,3.678-4.124,3.678-8.326,0-7.506-4.564-16.227-10.194-19.478-2.405-1.389-4.613-1.545-6.356-.695l-13.817,8.074a7.162,7.162,0,0,1,6.771.477c5.63,3.251,10.194,11.972,10.194,19.478,0,4.2-1.657,7.188-3.9,8.385Z",
    transform: "translate(-1128.046 -624.013)",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_415",
    "data-name": "Ellipse 415",
    cx: 8.854,
    cy: 15.65,
    rx: 8.854,
    ry: 15.65,
    transform: "matrix(0.92, -0.392, 0.392, 0.92, 0, 11.561)",
    fill: "#a88143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44075",
    "data-name": "Path 44075",
    d: "M1151.787,652.017c0,7.216-4.388,10.533-9.8,7.409s-9.8-11.508-9.8-18.724,4.388-10.533,9.8-7.408S1151.787,644.8,1151.787,652.017Z",
    transform: "translate(-1128.178 -623.667)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44076",
    "data-name": "Path 44076",
    d: "M1138.636,659.672c0,7.217-4.389,10.534-9.8,7.409s-9.8-11.509-9.8-18.726,4.389-10.534,9.8-7.409S1138.636,652.455,1138.636,659.672Z",
    transform: "translate(-1115.07 -618.842)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44077",
    "data-name": "Path 44077",
    d: "M1120.4,642.565l-4.023,7.308,7.026,16.8,8.6,1.4s5.978-4.26,2.978-13.434S1120.4,642.565,1120.4,642.565Z",
    transform: "translate(-1115.183 -618.722)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44078",
    "data-name": "Path 44078",
    d: "M1127.653,660.988c0,4.574-2.781,6.676-6.211,4.7s-6.21-7.292-6.21-11.867,2.781-6.675,6.21-4.7S1127.653,656.415,1127.653,660.988Z",
    transform: "translate(-1115.232 -618.475)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44079",
    "data-name": "Path 44079",
    d: "M1135.688,632.736l-5.457,3.189,11.758,27.8,6.911-4.076Z",
    transform: "translate(-1114.592 -619.142)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8740",
    "data-name": "Group 8740",
    transform: "translate(1093.301 640.865)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_416",
    "data-name": "Ellipse 416",
    cx: 11.99,
    cy: 21.194,
    rx: 11.99,
    ry: 21.194,
    transform: "matrix(0.92, -0.392, 0.392, 0.92, 0, 9.39)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44080",
    "data-name": "Path 44080",
    d: "M1130.288,669.06a17.614,17.614,0,0,1-9.184,13.159c-3.417,1.674-21.595-36.23-17.949-38.333,3.173-1.829,8.544-2.727,12.722-.947C1124.853,646.767,1131.3,658.462,1130.288,669.06Z",
    transform: "translate(-1092.901 -638.797)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 11.2,
    cy: 19.798,
    rx: 11.2,
    ry: 19.798,
    transform: "matrix(0.92, -0.392, 0.392, 0.92, 1.264, 10.366)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8735",
    "data-name": "Group 8735",
    transform: "translate(16.187 10.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44081",
    "data-name": "Path 44081",
    d: "M1108.825,655.668c0,5.668,3.445,12.251,7.7,14.706s7.7-.151,7.7-5.818c0-.044,0-.089,0-.132a34,34,0,0,0-6.436-13.7,10.352,10.352,0,0,0-1.255-.874C1112.27,647.4,1108.825,650,1108.825,655.668Z",
    transform: "translate(-1108.825 -648.927)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8736",
    "data-name": "Group 8736",
    transform: "translate(21.706 19.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44082",
    "data-name": "Path 44082",
    d: "M1115.435,657.734l-.849.46,1.885,3.9.8-.4-.164-2.464Z",
    transform: "translate(-1114.098 -657.657)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44083",
    "data-name": "Path 44083",
    d: "M1117.727,660.536c0,1.044-.634,1.522-1.416,1.071a3.392,3.392,0,0,1-1.416-2.706c0-1.043.634-1.522,1.416-1.071A3.392,3.392,0,0,1,1117.727,660.536Z",
    transform: "translate(-1114.085 -657.66)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44084",
    "data-name": "Path 44084",
    d: "M1116.951,660.958c0,1.044-.634,1.522-1.417,1.071a3.392,3.392,0,0,1-1.416-2.706c0-1.043.634-1.522,1.416-1.071A3.389,3.389,0,0,1,1116.951,660.958Z",
    transform: "translate(-1114.118 -657.642)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8737",
    "data-name": "Group 8737",
    transform: "translate(19.656 21.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44085",
    "data-name": "Path 44085",
    d: "M1115.16,659.234l-2.835,1.693.824,1.664,2.81-1.631-.071-1.074Z",
    transform: "translate(-1112.145 -659.2)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44086",
    "data-name": "Path 44086",
    d: "M1116.059,660.455c0,.455-.276.663-.617.466a1.477,1.477,0,0,1-.617-1.179c0-.455.276-.663.617-.466A1.476,1.476,0,0,1,1116.059,660.455Z",
    transform: "translate(-1112.038 -659.202)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44087",
    "data-name": "Path 44087",
    d: "M1113.387,662.05c0,.455-.276.664-.617.467a1.478,1.478,0,0,1-.617-1.179c0-.455.276-.663.617-.467A1.48,1.48,0,0,1,1113.387,662.05Z",
    transform: "translate(-1112.152 -659.134)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8738",
    "data-name": "Group 8738",
    transform: "translate(5.048 23.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44088",
    "data-name": "Path 44088",
    d: "M1113.075,661.244l-14.932,8.627.451.91,14.919-8.594-.039-.587Z",
    transform: "translate(-1098.142 -661.226)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44089",
    "data-name": "Path 44089",
    d: "M1113.019,661.912c0,.249-.151.363-.338.255a.808.808,0,0,1-.338-.645c0-.248.151-.363.338-.255A.811.811,0,0,1,1113.019,661.912Z",
    transform: "translate(-1097.536 -661.226)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8739",
    "data-name": "Group 8739",
    transform: "translate(2.993 29.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44090",
    "data-name": "Path 44090",
    d: "M1100.3,671.242c0,1.3-.793,1.9-1.772,1.339a4.242,4.242,0,0,1-1.771-3.383c0-1.3.794-1.9,1.771-1.34A4.243,4.243,0,0,1,1100.3,671.242Z",
    transform: "translate(-1096.146 -667.646)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44091",
    "data-name": "Path 44091",
    d: "M1097.425,667.736l-.748.392,2.433,4.831.712-.38Z",
    transform: "translate(-1096.149 -667.642)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44092",
    "data-name": "Path 44092",
    d: "M1099.713,671.54c0,1.3-.793,1.9-1.771,1.34a4.243,4.243,0,0,1-1.77-3.385c0-1.3.792-1.9,1.77-1.339A4.241,4.241,0,0,1,1099.713,671.54Z",
    transform: "translate(-1096.171 -667.633)",
    fill: "#ddd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8743",
    "data-name": "Group 8743",
    transform: "translate(1160.948 637.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8741",
    "data-name": "Group 8741",
    transform: "translate(0 14.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44093",
    "data-name": "Path 44093",
    d: "M1158.872,649.631l18.99,10.972-.573,1.158-18.973-10.929.05-.747Z",
    transform: "translate(-1158.173 -649.607)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44094",
    "data-name": "Path 44094",
    d: "M1158.179,650.481c0,.316.193.461.429.324a1.027,1.027,0,0,0,.43-.821c0-.316-.192-.462-.43-.324A1.028,1.028,0,0,0,1158.179,650.481Z",
    transform: "translate(-1158.179 -649.608)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8742",
    "data-name": "Group 8742",
    transform: "translate(0 6.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44095",
    "data-name": "Path 44095",
    d: "M1158.872,641.664l18.99,10.972-.573,1.157-18.973-10.929.05-.747Z",
    transform: "translate(-1158.173 -641.641)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44096",
    "data-name": "Path 44096",
    d: "M1158.179,642.514c0,.316.193.462.429.325a1.029,1.029,0,0,0,.43-.822c0-.316-.192-.461-.43-.324A1.031,1.031,0,0,0,1158.179,642.514Z",
    transform: "translate(-1158.179 -641.642)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44097",
    "data-name": "Path 44097",
    d: "M1208.231,660.8l-41.888-24.154v28.284l41.888,24.154Z",
    transform: "translate(-1157.831 -635.725)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44098",
    "data-name": "Path 44098",
    d: "M1208.183,658.928l-1.666.926v28.284l1.666-.926Z",
    transform: "translate(-1156.116 -634.774)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44099",
    "data-name": "Path 44099",
    d: "M1206.84,661.691l-39.151-22.573v24.931l39.151,22.573Z",
    transform: "translate(-1157.773 -635.62)",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44100",
    "data-name": "Path 44100",
    d: "M1209.9,659.917l-1.666.926-41.888-24.154,1.666-.926Z",
    transform: "translate(-1157.831 -635.763)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3021",
    "data-name": "Rectangle 3021",
    width: 0.666,
    height: 27.157,
    transform: "translate(17.077 6.477)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3022",
    "data-name": "Rectangle 3022",
    width: 0.666,
    height: 27.157,
    transform: "translate(25.241 11.602)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3023",
    "data-name": "Rectangle 3023",
    width: 0.666,
    height: 27.157,
    transform: "translate(33.406 15.976)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3024",
    "data-name": "Rectangle 3024",
    width: 0.666,
    height: 27.157,
    transform: "translate(41.57 21.101)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44101",
    "data-name": "Path 44101",
    d: "M1207.662,669.354l-41.005-23.645v.923l41.005,23.645Z",
    transform: "translate(-1157.817 -635.338)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44102",
    "data-name": "Path 44102",
    d: "M1207.662,677.868l-41.005-23.645v.923l41.005,23.645Z",
    transform: "translate(-1157.817 -634.975)",
    fill: "#ddd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfoSetlitesec);
export default __webpack_public_path__ + "static/media/ufo_setlitesec.a6383b5566c011e5a5fb2e3383d88f22.svg";
export { ForwardRef as ReactComponent };